<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="title-wrapper mb-4">
      <div>
        <h1 class="title-default">FCI</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          @if (editando) {
          Editando ficha nº {{ numeroFormatado(idFci!) }} · {{ dataCriacao | date:'dd/MM/yyyy' }}
          } @else {
          Nova ficha · {{ dataCriacao | date:'dd/MM/yyyy' }}
          }
        </p>
      </div>
    </div>

    @if (isLoading) {
    <div class="section-container">
      <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
      <app-loading-box height="200" width="100%" marginTop="24"></app-loading-box>
    </div>
    } @else {
    <!-- Aviso fixo (padrão HUB) — cálculo manual -->
    <div class="mb-3">
      <app-alert-card type="info">
        O sistema gera o arquivo para importação no validador da SEFAZ, mas não realiza os cálculos automáticos do valor
        da parcela e do percentual de importação. Por favor, insira esses dados manualmente para prosseguir. Em caso de
        dúvidas sobre os valores, consulte a sua contabilidade.
      </app-alert-card>
    </div>

    <!-- Protocolo de recepção -->
    <div class="section-container">
      <h2 class="section-title">
        <mat-icon class="material-symbols-outlined">confirmation_number</mat-icon>
        <span>Protocolo de recepção</span>
      </h2>
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>Protocolo de recepção</mat-label>
            <input matInput [(ngModel)]="protocoloRecepcao" placeholder="Informe após transmitir no portal do SEFAZ" />
            <mat-hint>O protocolo de recepção é obtido após o envio da FCI. Seu preenchimento não é
              obrigatório.</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Mercadorias -->
    <div class="section-container mt-3">
      <h2 class="section-title">
        <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
        <span>Mercadorias</span>
        <span class="status-badge badge-cinza">{{ itens.length }} {{ itens.length === 1 ? 'item' : 'itens' }}</span>
        <div class="section-title-actions ms-auto">
          <button mat-flat-button class="btn-secondary" type="button" (click)="abrirItem(null, null)">
            <mat-icon class="material-symbols-outlined">add</mat-icon> <span class="action-btn-text">Adicionar
              mercadoria</span>
          </button>
        </div>
      </h2>

      @if (itens.length === 0) {
      <app-empty-state icon="inventory_2" title="Nenhuma mercadoria adicionada"
        subtitle="Comece adicionando as mercadorias desta ficha."></app-empty-state>
      } @else {
      <div class="table-responsive desktop-view">
        <table mat-table [dataSource]="itens" class="w-100">
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef>Nome</th>
            <td mat-cell *matCellDef="let row">
              <div>{{ row.descricao }}</div>
              @if (row.codigoFci) {
              <div class="codigo-fci-mono">nFCI {{ row.codigoFci }}</div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="cod">
            <th mat-header-cell *matHeaderCellDef>Cód</th>
            <td mat-cell *matCellDef="let row" class="mono">{{ row.codigoSku }}</td>
          </ng-container>

          <ng-container matColumnDef="ncm">
            <th mat-header-cell *matHeaderCellDef>NCM</th>
            <td mat-cell *matCellDef="let row" class="mono">{{ row.ncm }}</td>
          </ng-container>

          <ng-container matColumnDef="un">
            <th mat-header-cell *matHeaderCellDef>UN</th>
            <td mat-cell *matCellDef="let row">{{ row.unidade }}</td>
          </ng-container>

          <ng-container matColumnDef="valorSaida">
            <th mat-header-cell *matHeaderCellDef class="text-end">Valor saída</th>
            <td mat-cell *matCellDef="let row" class="text-end">{{ row.valorSaida | currency:'BRL' }}</td>
          </ng-container>

          <ng-container matColumnDef="pct">
            <th mat-header-cell *matHeaderCellDef class="text-end">Cont. imp. %</th>
            <td mat-cell *matCellDef="let row" class="text-end">{{ row.percentualConteudoImportacao }}%</td>
          </ng-container>

          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center">Ação</th>
            <td mat-cell *matCellDef="let row; let i = index" class="text-center">
              <button mat-icon-button (click)="abrirItem(row, i)" matTooltip="Editar">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="excluirItem(i)" matTooltip="Excluir">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['nome','cod','ncm','un','valorSaida','pct','acoes']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['nome','cod','ncm','un','valorSaida','pct','acoes'];"></tr>
        </table>
      </div>

      <!-- Mobile cards -->
      <div class="mobile-view">
        @for (row of itens; track row.idProduto; let i = $index) {
        <div class="card-mobile mb-3">
          <div class="card-header-mobile d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column">
              <span>{{ row.descricao }}</span>
              @if (row.codigoFci) {
              <span class="codigo-fci-mono">nFCI {{ row.codigoFci }}</span>
              }
            </div>
            <button mat-icon-button [matMenuTriggerFor]="menuMobile" (click)="$event.stopPropagation()">
              <span class="material-symbols-outlined">more_horiz</span>
            </button>
            <mat-menu #menuMobile="matMenu">
              <button mat-menu-item (click)="abrirItem(row, i)">
                <span class="material-symbols-outlined">edit</span>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="excluirItem(i)">
                <span class="material-symbols-outlined">delete</span>
                <span>Excluir</span>
              </button>
            </mat-menu>
          </div>
          <div class="card-body-mobile p-3">
            <div class="row">
              <div class="col-6 mb-1">
                <small class="d-block text-secondary">Cód</small>
                <span class="mono">{{ row.codigoSku }}</span>
              </div>
              <div class="col-6 mb-1">
                <small class="d-block text-secondary">NCM</small>
                <span class="mono">{{ row.ncm }}</span>
              </div>
              <div class="col-6 mb-1">
                <small class="d-block text-secondary">UN</small>
                <span>{{ row.unidade }}</span>
              </div>
              <div class="col-6 mb-1">
                <small class="d-block text-secondary">Valor saída</small>
                <span>{{ row.valorSaida | currency:'BRL' }}</span>
              </div>
              <div class="col-6 mb-1">
                <small class="d-block text-secondary">Cont. imp. %</small>
                <span>{{ row.percentualConteudoImportacao }}%</span>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
  (salvar)="salvar()"></app-footer-action>